import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(theme => ({
  chipRoot: {
    borderRadius: theme.spacing(5),
    padding: theme.spacing(1, 2),
    backgroundColor: theme.palette.secondary['clr-100'],
    width: 'fit-content',
    display: 'flex', gap: theme.spacing(1),
    zIndex:1,
    alignItems: 'center',
  },
  clickableChip: {
    borderRadius: theme.spacing(5),
    textTransform: 'capitalize',
    padding: theme.spacing(2, 4),
    backgroundColor: theme.palette.shades['clr-white-900'],
    border: '1px solid',
    borderColor: theme.palette.neutral['clr-600'],
    boxShadow: '0px 0px 4px 0px #00000033',
    width: 'fit-content',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.primary['clr-50'],
    }
  },
  selectedChip: {
    backgroundColor: theme.palette.primary.main,
    '&>*': {
      color: theme.palette.shades['clr-white-900']
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    }
  },
  disabledChip: {
    backgroundColor: theme.palette.neutral.disabled,
    cursor: 'default',
    '&:hover': {
      backgroundColor: theme.palette.neutral.disabled,
    }
  },
  disabledRootChip: {
    backgroundColor: `${theme.palette.neutral['clr-200']} !important`,
    color: `${theme.palette.neutral['clr-600']} !important`
  }
}
));

const Chip = ({ 
  content, color, bgColor, startIcon = null, endIcon = null, sx = {}, disabled,
  typographyVariant = 'body01-bold', style = {}, ...props 
}) => {
  const classes = useStyles();

  const chipStyle = {
    ...sx,
    ...style,
    ...(color && { color }),
    ...(bgColor && !disabled && { backgroundColor: bgColor }),
  };

  return (
    <Box 
      className={`${classes.chipRoot} ${disabled ? classes.disabledRootChip : ''}`} 
      style={chipStyle} 
      {...props}
    >
      {
        startIcon && startIcon
      }
      <Typography variant={typographyVariant}>
        {content}
      </Typography>
      {
        endIcon && endIcon
      }
    </Box>
  )
}

export default Chip;